/** Feature flags — gate marketing claims until integrations are live. */
const flags = {
  aiSoap: true,
  stripeBilling: process.env.REACT_APP_STRIPE_ENABLED === "true",
  efacturaLive: process.env.REACT_APP_EFACTURA_ENABLED === "true",
  insuranceClaims: false,
  telehealthHd: true,
  /** Group-size claims are not verified uniformly; hide until explicitly enabled. */
  telehealthGroupSessions: process.env.REACT_APP_TELEHEALTH_GROUP_SESSIONS === "true",
  hrModule: process.env.REACT_APP_HR_MODULE !== "false",
}

export function isEnabled(key) {
  return Boolean(flags[key])
}

const FLAG_STRIP_RES = {
  stripeBilling: /stripe|plată online|online fizetés|Facturare recurent|Ismétlődő száml|recurring/i,
  efacturaLive: /insurance|claim|e-factura|e-factură|asigurat/i,
  telehealthGroupSessions: /(Ședințe de grup|Group sessions|csoportos session|12 főig|up to 12|akár 12)/i,
  hrModule: /(HR România|REGES|contracte CIM|modul APP|state de plată)/i,
}

export function filterBullets(bullets, requiredFlag) {
  if (!Array.isArray(bullets)) return bullets
  if (!requiredFlag || isEnabled(requiredFlag)) return bullets
  const re = FLAG_STRIP_RES[requiredFlag]
  if (!re) return bullets.filter((b) => !/insurance|claim|e-factura live/i.test(b))
  return bullets.filter((b) => !re.test(b))
}
